import React, { useEffect, useState } from "react";
import clsx from "clsx";

import { VOTE_STATUS } from "../../../consts/hotColdVote";

import { formatTimeToString, remainTime } from "../../../libs/dateFormat";

import { VoteStatus } from "../../../services/hotColdVoteServices";

import { Skeleton } from "../../../pages/Talk";

type HotColdVoteRemainTimeProps = {
  className?: string;
  status?: VoteStatus;
  endTime?: string;
  prefix?: React.ReactNode;
  onlyNumber?: boolean;
  onRefresh?: () => void;
  onEnd?: () => void;
};

export const HotColdVoteRemainTime = ({
  className,
  status,
  endTime,
  prefix,
  onlyNumber = false,
  onRefresh,
  onEnd,
}: HotColdVoteRemainTimeProps) => {
  const [remainString, setRemainString] = useState("");
  const [isEnd, setIsEnd] = useState<boolean>(false);
  let loadTimeInterval: NodeJS.Timeout;

  useEffect(() => {
    let timeInterval: NodeJS.Timeout;

    if (status === VOTE_STATUS.ONGOING) {
      timeInterval = setInterval(() => {
        const remainMs = remainTime(endTime ?? "", 0);
        if (remainMs > 0) {
          setRemainString(formatTimeToString(remainMs));
        } else {
          setIsEnd(true);
          clearInterval(timeInterval);

          if (onRefresh) {
            onRefresh();
            loadTimeInterval = setInterval(onRefresh, 10000);
          }
        }
      }, 1000);
    } else if (status === VOTE_STATUS.COMPLETED) {
      setIsEnd(true);
      clearInterval(loadTimeInterval);
    }

    return () => {
      clearInterval(loadTimeInterval);
      clearInterval(timeInterval);
    };
  }, [status]);

  useEffect(() => {
    if (!isEnd) return;

    if (onlyNumber) {
      onEnd?.();
    } else {
      setRemainString("투표가 종료되었습니다.");
    }
  }, [isEnd]);

  useEffect(() => {
    const time = remainTime(endTime ?? "", 0);
    if (time > 0) {
      setRemainString(formatTimeToString(time));
    }
  }, []);

  return (
    <>
      {!isEnd && remainString === "" ? (
        <Skeleton className="h-[20px] w-[50px] rounded-lg" />
      ) : (
        <div
          className={clsx(
            "flex items-center gap-1.5 text-xs font-normal leading-[20px]",
            className,
            {
              "text-brand-primary-gray-100": onlyNumber,
              "text-brand-neutral-50 h-[20px]": !onlyNumber,
            }
          )}
        >
          {!isEnd ? prefix : null}
          <span className="min-w-[33px]">{remainString}</span>
        </div>
      )}
    </>
  );
};
